import React from 'react';

import './Image.css'

import classnames from 'classnames'
import { getIcon } from '../GetMaterialIcon'
import OverlayMenu from './OverlayMenu';
import { apiServerHost, imageServerHost } from '../common/APIServerSettings';

const Image = (props) => {
  // Property value
  const { id, index, name, value, resource, col } = props
  // Option props 
  const { maxWidth } = props
  // Property functions
  const { menuOnShow, menuOnHide, updateComponent } = props

  const onUpdate = (updatedName, updatedValue) => {
    updateComponent({
      [updatedName]: updatedValue,
    })
  }

  const onShow = (e) => {
    menuOnShow()
  }

  const onHide = (e) => {
    menuOnHide()
  }
  
  const componentWrapClassname = classnames('component-wrapper', {
    'max': maxWidth,
  })
  const imgWrapClassname = classnames('img-wrap', {
    'img-col-2': col === 2,
    'img-col-3': col === 3,
  })

  return (
    <OverlayMenu
      id={id}
      name={name}
      value={value}
      resource={resource}
      onUpdate={onUpdate}
      onShow={onShow} onHide={onHide} >
      <div className="img-component">
        <div className={componentWrapClassname}>
          <div className={imgWrapClassname}>
            {render_resource(name, resource, col)}
          </div>
          <div className='img-name-wrap'> <span className="img-name">{render_name(name)}</span> </div>
        </div>
      </div>
    </OverlayMenu> 
  )
}

const render_name = (name) => {
  if (name) {
    if (name.trim() === "") {
      return "이름 없음"
    }
    return name
  }
  return "이름 없음"
}

const render_resource = (name, resource, col) => {
  if (resource) {
    if (resource.trim() === "") {
      return <NoImage col={col} />
    }
    return <img className="img-content" src={`${imageServerHost}/service/img?name=`+resource} alt={name} name={resource} />
  }
  return (
    <NoImage col={col} />
  )
}

const NoImage = (props) => {
  const { col } = props
  const textLineHeight = col === 1 ? 200 : col === 2 ? 150 : 100
  const textSize = col === 3 ? 10 : 14

  return (
    <p style={{lineHeight: textLineHeight+'px', fontSize: textSize+'px'}}> 이미지 없음 </p>
  )
}

export default Image